import gql from 'graphql-tag'

export const GET_ALL_ORGANIZATION_PREPAID_COUPON_USERS = gql`
  query GetAllPrepaidCouponUsers($organizationSlug: String!) {
    getAllPrepaidCouponUsers(organizationSlug: $organizationSlug) {
      id
      name
      email
      redeemedCouponItems
      createdAt
      prepaidCoupon {
        name
        price
        currency
        description
        from
        to
        couponItems {
          id
          type
          ticketAmount
        }
      }
    }
  }
`

export const GET_ALL_SPORT_ORGANIZATION_PREPAID_COUPON_USERS = gql`
  query GetAllSportPrepaidCouponUsers(
    $organizationSlug: String!
    $searchTerm: String
    $pagination: Pagination
    $prepaidCouponId: ID
  ) {
    getAllSportPrepaidCouponUsers(
      organizationSlug: $organizationSlug
      searchTerm: $searchTerm
      pagination: $pagination
      prepaidCouponId: $prepaidCouponId
    )
  }
`

export const GET_SPORT_PREPAID_COUPON_USERS_LIST = gql`
  query GetSportPrepaidCouponUsersList(
    $organizationSlug: String!
    $searchTerm: String
    $pagination: Pagination
    $prepaidCouponId: ID
  ) {
    getSportPrepaidCouponUsersList(
      organizationSlug: $organizationSlug
      searchTerm: $searchTerm
      pagination: $pagination
      prepaidCouponId: $prepaidCouponId
    ) {
      count
      items {
        id
        name
        email
        qrcode
        createdAt
        fields
        prepaidCoupon {
          id
          name
          to
        }
      }
    }
  }
`

export const GET_SPORT_PREPAID_COUPON_USER_DETAILS = gql`
  query GetSportPrepaidCouponUserDetails($organizationSlug: String!, $id: ID!) {
    getSportPrepaidCouponUserDetails(organizationSlug: $organizationSlug, id: $id) {
      id
      name
      email
      code
      qrcode
      fields
      flags
      createdAt
      prepaidCouponId
      prepaidCoupon {
        id
        name
        organization {
          attendeeFields
        }
      }
      accreditations {
        id
        event {
          title
          from
        }
        scanEventEntry {
          createdAt
        }
      }
    }
  }
`

export const UPDATE_PREPAID_COUPON_USER_FLAGS = gql`
  mutation UpdatePrepaidCouponUserFlags(
    $organizationSlug: String!
    $prepaidCouponUserId: ID!
    $flags: JSON!
  ) {
    updatePrepaidCouponUserFlags(
      organizationSlug: $organizationSlug
      prepaidCouponUserId: $prepaidCouponUserId
      flags: $flags
    )
  }
`

export const GET_ORGANIZATION_PREPAID_COUPON_USERS = gql`
  query GetOrganizationPrepaidCouponUsers($organizationSlug: String!) {
    getOrganizationPrepaidCouponUsers(organizationSlug: $organizationSlug) {
      id
      name
      email
      fields
      prepaidCoupon {
        id
        name
        season
      }
    }
    getFutureOrganizationEvents(organizationSlug: $organizationSlug) {
      id
      title
      from
    }
  }
`

export const CREATE_SPORT_MEMBERSHIP_PREPAID_USER = gql`
  mutation CreateSportPrepaidCouponUser(
    $dto: UserSportSubscriptionUserInput!
    $organizationSlug: String!
  ) {
    createSportPrepaidCouponUser(dto: $dto, organizationSlug: $organizationSlug)
  }
`

export const UPDATE_SPORT_PREPAID_COUPON_USER = gql`
  mutation UpdateSportPrepaidCouponUser(
    $organizationSlug: String!
    $id: ID!
    $dto: UserSportSubscriptionUserInput!
  ) {
    updateSportPrepaidCouponUser(organizationSlug: $organizationSlug, id: $id, dto: $dto)
  }
`

export const GET_TOTAL_SPORT_PREPAID_COUPON_USERS_SOLD_DATA = gql`
  query GetTotalSportPrepaidCouponUsersSoldData(
    $organizationSlug: String!
    $prepaidCouponId: ID
    $purchaseSource: String
  ) {
    getTotalSportPrepaidCouponUsersSoldData(
      organizationSlug: $organizationSlug
      prepaidCouponId: $prepaidCouponId
      purchaseSource: $purchaseSource
    ) {
      soldItems
      totalIncome
    }
  }
`

export const GET_PREPAID_COUPON_USERS_GROUPED_BY_CREATED_AT_DATE = gql`
  query GetPrepaidCouponUsersGroupedByCreatedAtDate(
    $organizationSlug: String!
    $prepaidCouponId: ID
    $startDate: String
    $endDate: String
    $purchaseSource: String
  ) {
    getPrepaidCouponUsersGroupedByCreatedAtDate(
      organizationSlug: $organizationSlug
      prepaidCouponId: $prepaidCouponId
      startDate: $startDate
      endDate: $endDate
      purchaseSource: $purchaseSource
    )
  }
`

export const GET_PREPAID_COUPON_USERS_GROUPED_BY_CREATED_AT_MONTH = gql`
  query GetPrepaidCouponUsersGroupedByCreatedAtMonth(
    $organizationSlug: String!
    $prepaidCouponId: ID
    $startDate: String
    $endDate: String
    $purchaseSource: String
  ) {
    getPrepaidCouponUsersGroupedByCreatedAtMonth(
      organizationSlug: $organizationSlug
      prepaidCouponId: $prepaidCouponId
      startDate: $startDate
      endDate: $endDate
      purchaseSource: $purchaseSource
    )
  }
`

export const GET_PREPAID_COUPON_USERS_GROUPED_BY_PREPAID_COUPON_ID = gql`
  query GetPrepaidCouponUsersGroupedByPrepaidCouponId(
    $organizationSlug: String!
    $prepaidCouponId: ID
    $purchaseSource: String
  ) {
    getPrepaidCouponUsersGroupedByPrepaidCouponId(
      organizationSlug: $organizationSlug
      prepaidCouponId: $prepaidCouponId
      purchaseSource: $purchaseSource
    )
  }
`

export const GET_PREPAID_COUPON_USERS_CUMULATIVE_INCOME_GROUPED_BY_CREATED_AT_DATE = gql`
  query GetPrepaidCouponUsersCumulativeIncomeGroupedByCreatedAtDate(
    $organizationSlug: String!
    $prepaidCouponId: ID
    $startDate: String
    $endDate: String
    $purchaseSource: String
  ) {
    getPrepaidCouponUsersCumulativeIncomeGroupedByCreatedAtDate(
      organizationSlug: $organizationSlug
      prepaidCouponId: $prepaidCouponId
      startDate: $startDate
      endDate: $endDate
      purchaseSource: $purchaseSource
    )
  }
`

export const GET_PREPAID_COUPON_USER_BY_ID = gql`
  query GetPrepaidCouponUsersBy($organizationSlug: String!, $id: ID!) {
    getPrepaidCouponUserById(organizationSlug: $organizationSlug, id: $id) {
      fields
      name
      email
      qrcode
      prepaidCouponId
    }
  }
`
